import React from 'react';
import './CandidateDetail.scss';
import Markdown from 'react-markdown';
import { motion, useReducedMotion } from 'motion/react';
import { ICandidate } from 'store/reducers/elections/types';
import { ReactComponent as VKIcon } from 'assets/icons/VK.svg';

interface CandidateDetailProps {
    candidate: ICandidate;
}
const SECTION_INITIAL = { opacity: 0, y: 8 };
const SECTION_ANIMATE = { opacity: 1, y: 0 };

function CandidateDetail({
    candidate,
}: CandidateDetailProps): React.ReactElement {
    const reduced = useReducedMotion();
    const sectionTransition = {
        duration: reduced ? 0 : 0.22,
        delay: reduced ? 0 : 0.12,
    };

    return (
        <div className="rd-candidate">
            <div className="rd-candidate__head">
                <span
                    className="rd-candidate__photo"
                    style={{ backgroundImage: `url(${candidate.picture})` }}
                />
                <div className="rd-candidate__info">
                    <h3 className="rd-candidate__name">
                        {candidate.first_name} {candidate.last_name}
                    </h3>
                    <p className="rd-candidate__sub">
                        {[
                            candidate.group.faculty.name,
                            `курс ${candidate.course}`,
                            candidate.group.name,
                        ].join(', ')}
                    </p>
                    <div className="rd-candidate__contacts">
                        {candidate.vk_nick && (
                            <a
                                href={candidate.vk_nick}
                                target="_blank"
                                rel="noreferrer"
                                aria-label="ВКонтакте"
                            >
                                <VKIcon />
                            </a>
                        )}
                    </div>
                </div>
            </div>

            <motion.div
                key={`${candidate.id}-desc`}
                className="rd-candidate__section"
                initial={SECTION_INITIAL}
                animate={SECTION_ANIMATE}
                transition={sectionTransition}
            >
                <h4>О себе</h4>
                <div className="rd-candidate__markdown">
                    <p className="rd-candidate__description">
                        {candidate.description_text}
                    </p>
                </div>
            </motion.div>

            <motion.div
                key={`${candidate.id}-program`}
                className="rd-candidate__section"
                initial={SECTION_INITIAL}
                animate={SECTION_ANIMATE}
                transition={sectionTransition}
            >
                <h4>Предвыборная программа</h4>
                <div className="rd-candidate__markdown">
                    <Markdown>{candidate.program_text}</Markdown>
                </div>
            </motion.div>
        </div>
    );
}

export default React.memo(CandidateDetail);
